import { call, put, select, takeLatest } from "redux-saga/effects";
import { setRequestInProcess } from "../request/actions";
import {
  fetchingDashboardDataError,
  fetchingDashboardDataSuccess,
  fetchingInvoiceTypesError,
  fetchingInvoiceTypesSuccess
} from "./actions";
import { dateRangeSelector, selectedTypeSelector } from "./selectors";
import invoicesApiService from "../../services/invoicesApiService";
import { dashboardDataAdapter } from "../../utils/dashboardAdaptor";
import { dateToStartOfDay, dateToEndOfDay, addDataToErrors, dateAdapter } from "../../utils/helpers";
import { FETCH_DASHBOARD_DATA, FETCH_INVOICE_TYPES } from "./types";
import { showModal } from "../modal/actions";
import modalNames from "../../constants/modalNames";

function* fetchingDashboardDataAsync() {
  try {
    yield put(setRequestInProcess(FETCH_DASHBOARD_DATA, true));

    const ranges = yield select(dateRangeSelector);
    const selectedType = yield select(selectedTypeSelector);

    const filters = {
      from: ranges.from ? dateToStartOfDay(new Date(ranges.from)) : ranges.from,
      to: ranges.to ? dateToEndOfDay(new Date(ranges.to)) : ranges.to
    };

    if (selectedType) {
      filters.invoiceType = selectedType;
    }

    const response = yield call(x => invoicesApiService.getDashboardData(x), dateAdapter(filters));

    yield put(setRequestInProcess(FETCH_DASHBOARD_DATA, false));
    if (response.hasError) {
      yield put(fetchingDashboardDataError(response.errors));
      yield put(
        showModal(modalNames.ERROR_MODAL, {
          errors: addDataToErrors(response.errors, { helpDeskEmail: process.env.REACT_APP_HELP_DESK_EMAIL })
        })
      );
    } else {
      yield put(fetchingDashboardDataSuccess(dashboardDataAdapter(response.payload)));
    }
  } catch (err) {
    yield put(fetchingDashboardDataError([err.message]));
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

function* watchFetchingDashboardDataAsync() {
  yield takeLatest(FETCH_DASHBOARD_DATA, fetchingDashboardDataAsync);
}

function* fetchingInvoiceTypesAsync() {
  try {
    yield put(setRequestInProcess(FETCH_INVOICE_TYPES, true));

    const response = yield call(() => invoicesApiService.getInvoiceTypes());

    yield put(setRequestInProcess(FETCH_INVOICE_TYPES, false));

    if (response.hasError) {
      yield put(fetchingInvoiceTypesError(response.errors));
    } else {
      yield put(fetchingInvoiceTypesSuccess(response.payload));
    }
  } catch (err) {
    yield put(fetchingInvoiceTypesError([err.message]));
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

function* watchFetchingInvoiceTypesAsync() {
  yield takeLatest(FETCH_INVOICE_TYPES, fetchingInvoiceTypesAsync);
}

export { watchFetchingDashboardDataAsync, watchFetchingInvoiceTypesAsync };
